import { useCachedPromise } from "@/hooks/useCachedPromise";
import { fetchGlossaryTerms, type GlossaryConfig } from "@/modules/config";

const GLOSSARY_TERMS_CACHE_KEY = "glossary-terms-config";

// Backs every widget- and page-level insight popup, so this shares one cached fetch
// (via useCachedPromise's module-level cache) instead of each widget's own insights
// popup re-fetching the same glossary on mount.
export function useGlossaryTerms(): GlossaryConfig | undefined {
    const { data } = useCachedPromise<GlossaryConfig>(() => fetchGlossaryTerms(), GLOSSARY_TERMS_CACHE_KEY);
    return data;
}
